import { HasAuthorityDomain } from '../types/HasAuthorityDomain';
import { HasTenantDomain } from '../types/HasTenantDomain';

export const authorityBase = (b2cEnv: HasAuthorityDomain & HasTenantDomain) =>
	`https://${b2cEnv.authorityDomain}/${b2cEnv.tenantDomain}`;
